import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-e8b828a2")

_pushScopeId("data-v-e8b828a2")
const _hoisted_1 = { class: "colors-list" }
const _hoisted_2 = { class: "color-text" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_popover = _resolveComponent("el-popover")

  return (_openBlock(), _createBlock("div", {
    class: "m-color-select",
    onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
  }, [
    _createVNode(_component_el_popover, {
      placement: "bottom",
      width: _ctx.selectWidth,
      trigger: "manual",
      visible: _ctx.selectFocus,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectFocus = $event))
    }, {
      reference: _withId(() => [
        _createVNode("div", {
          class: "m-color-select-bar",
          style: _ctx.selectBarStyle,
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.setFocus && _ctx.setFocus(...args))),
          ref: "selectWrap"
        }, [
          _createVNode("span", {
            class: "select-color-preview",
            style: {
              backgroundColor: _ctx.selectVal.color,
              border:
                _ctx.selectVal.color.toLowerCase() === '#fff' ||
                _ctx.selectVal.color.toLowerCase() === '#ffffff'
                  ? '1px solid #ccc'
                  : 'none',
            }
          }, null, 4),
          _createTextVNode(" " + _toDisplayString(_ctx.selectVal.name || '请选择颜色') + " ", 1),
          _createVNode("input", {
            type: "hidden",
            value: _ctx.selectVal.color
          }, null, 8, ["value"]),
          _createVNode("i", {
            class: "el-icon-arrow-up",
            style: {
              transform: _ctx.selectFocus ? 'rotateZ(0deg)' : 'rotateZ(180deg)',
            }
          }, null, 4)
        ], 4)
      ]),
      default: _withId(() => [
        _createVNode("ul", _hoisted_1, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.colors, (item) => {
            return (_openBlock(), _createBlock("li", {
              key: item.color,
              onClick: ($event: any) => (_ctx.onSelect(item)),
              class: JSON.stringify(item) === JSON.stringify(_ctx.selectVal) ? 'active' : ''
            }, [
              _createVNode("span", {
                class: "color-preview",
                style: {
              backgroundColor: item.color,
              border:
                item.color.toLowerCase() === '#fff' || item.color.toLowerCase() === '#ffffff'
                  ? '1px solid #ccc'
                  : 'none',
            }
              }, null, 4),
              _createVNode("span", _hoisted_2, _toDisplayString(item.name), 1)
            ], 10, ["onClick"]))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["width", "visible"])
  ]))
})